/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IFeatures } from '@/hooks/useAuth'

type UserStateType = {
  email: string
  features: IFeatures | undefined
  accessToken: string | null
  refreshToken: string | null
  expiresIn: number | null
}

const initialState: UserStateType = {
  email: '',
  features: undefined,
  accessToken: null,
  refreshToken: null,
  expiresIn: null
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserEmail(state, action: PayloadAction<string>) {
      state.email = action.payload
    },
    setFeatures(state, action: PayloadAction<IFeatures | undefined>) {
      state.features = action.payload
    },
    setAccessToken(state, action: PayloadAction<string | null>) {
      state.accessToken = action.payload
    },
    setRefreshToken(state, action: PayloadAction<string | null>) {
      state.refreshToken = action.payload
    },
    setTokenExpire(state, action: PayloadAction<number | null>) {
      state.expiresIn = action.payload
    }
  }
})

export const { setUserEmail, setAccessToken, setFeatures, setRefreshToken, setTokenExpire } = authSlice.actions

export default authSlice.reducer
